import { Injectable } from '@angular/core';
import { AuthenticatedHttpService } from './authenticatedhttp.service';

import { Customer } from '../model/customer';

import { Observable } from 'rxjs';

@Injectable()
export class CustomerService {
    private baseUrl;
    private _customerCache: Customer;

    constructor(
        private _http: AuthenticatedHttpService
    ) {
        this.baseUrl = _http.getBaseURLFromCookie();
    }

    insertCustomer(customer: Customer): Observable<Customer> {

        return this._http.post(this.baseUrl + '/api/customer/create', JSON.stringify(customer))
            .map(x => {
                return this.mapCustomer(x.json());
            })
			.catch(this._http.handleError);
    }

    mapCustomer(apiCustomer): Customer {
        if (apiCustomer !== undefined && apiCustomer !== null) {
            let customer: Customer = new Customer();
            customer.customerId = apiCustomer.CustomerId;
            customer.firstName = apiCustomer.FirstName;
            customer.lastName = apiCustomer.LastName;
            customer.address = apiCustomer.StreetAddress;
            customer.city = apiCustomer.City;
            customer.email = apiCustomer.Email;
            customer.phone = apiCustomer.Phone;
            customer.state = apiCustomer.State;
            customer.zip = apiCustomer.ZIP;
            return customer;
        } else {
            return undefined;
        }
    }

    updateCustomer(customer: Customer): Observable<Customer> {

        return this._http.post(this.baseUrl + '/api/customer/update', JSON.stringify(customer))
            .map(x => { return this.mapCustomer(x.json()); })
            .do((response) => {
                if (response !== null) {
                    this._customerCache = response;
                } else {
                    this._customerCache = null;
                }
            })
			.catch(this._http.handleError);
    }

    ///Get a list of models
    ///limit: the number of models to get back
    ///offset: Where to start 
    ///refresh: whether to pull fresh from the database
    getCustomerById(customerId: number, refresh = false): Observable<Customer> {
        if (this._customerCache && !refresh) {
        
            return Observable.of(this._customerCache)
        } else {
            return this._http.get(this.baseUrl + `/api/customer/` + customerId)
                .map(x => { return this.mapCustomer(x.json()); })
                .do((response) => {
                    if (response !== null) {
                        this._customerCache = response;
                    } else {
                        this._customerCache = null;
                    }
                })
                .catch(this._http.handleError);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/customer.service.ts